import { Button, Modal, Checkbox, Row, Col } from 'antd';
import { useState, useEffect, useRef, useMemo } from 'react';

interface Property {
    opened: boolean;
    children?: any;
    onClosed?: any;
    display?: any;
}

const AdsModal = (props: Property) => {
    // const [cookies, setCookie] = useCookies(['user']);

    const [title, setTitle] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [agreeChecked, setAgreeChecked] = useState(false);
    const [pdfFullUrls, setPdfFullUrls] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const [tncList, setTncList] = useState([]);

    const [currentTNC, setCurrentTNC] = useState(null);
    const [isCAdsModalOpen, setIsCAdsModalOpen] = useState(false);

    const [buttonLoading, setButtonLoading] = useState(false);


    useEffect(() => {

        if (isModalOpen == true) {
           
        }
    }, [isModalOpen]);


    

    const handleCancel = () => {
        setIsModalOpen(false);
    };


    return (
        <>

            <Modal
                bodyStyle={{
                    overflowY: 'auto',
                    minHeight: '70vh',
                    maxHeight: '70vh',
                    minWidth: '50vw'
                }}
                title={<></>}
                open={isModalOpen}
                onCancel={handleCancel}
                width={'50vw'}
                okButtonProps={{ style: { display: 'none' } }}
                footer={[
                 
                ]}
               
            >
                <div style={{ position: 'relative', height: '100vh' }}>
                <div className="row">
                    <div className="col-md-6 col-12">
                        <div>Take a Vigilant Approach to Safeguard Your Investments</div>
                        <p>
                        Dear Investors,
                        In your pursuit of financial well-being, it is crucial to exercise unwavering vigilance when venturing into the realm of investments.
                        Take the time to research thoroughly, verify credentials and consult legitimate and reputable firms before investing.


                        We invite you to read our official Scam Alert List resource page which contain advisory on what to do if you fall victim to a scam, what you can do to protect yourself, and list of official resources to check for scams.


                        Stay alert. Be safe!
                        </p>
                    </div>
                    <div className="col-md-6 col-12">
                        <img width="100%" src="https://www.utrade.com.my/img/EDM/edm-scam-alert-approved.png" />
                    </div>
                </div>
                  
                
                </div>
            </Modal>
        </>
    );
};

export default AdsModal;
